module.exports = __webpack_public_path__ + "img/clippy.1e918ea2.svg";